import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden bg-bg-main" data-id="element-113">
      {/* Main headline */}
      <h1 className="relative font-serif font-black max-w-5xl text-[32px] leading-[1.12] sm:text-6xl md:text-7xl sm:leading-[1.1] mb-3 sm:mb-6 tracking-tight text-text-main" data-id="element-114">
        Plan an Entire Year of Yoga Classes{' '}
        <span className="text-primary font-serif" data-id="element-115">in just</span>{' '}
        <span className="text-primary italic font-serif" data-id="element-116">5 Minutes</span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-[15px] sm:text-xl font-medium leading-snug sm:leading-relaxed mb-4 sm:mb-10 max-w-2xl mx-auto text-text-sec" data-id="element-117">
        More than 1,200 teachers have already stopped improvising. Arrive at
        every class ready to teach, deepen, and transform.
      </p>

      {/* Product name */}
      <p className="relative text-primary font-serif font-bold text-base sm:text-2xl mb-4 sm:mb-8" data-id="element-118">
        YOGA READY — The 6-in-1 Professional Bundle
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[300px] sm:max-w-[520px] md:max-w-[620px] mx-auto mb-5 sm:mb-10" data-id="element-119">
        <img src="https://cdn.magicpatterns.com/uploads/u1TVKYh6MVJuWEVesx3rpp/Diseno-sin-titulo-_35_.webp" alt="YOGA READY — The Essential Collection for Yoga Teachers" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(42,92,69,0.15)]" width={620} height={620} fetchPriority="high" loading="eager" decoding="async" data-id="element-120" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-bold text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-full transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-primary hover:bg-primary-hover shadow-[0_10px_30px_-10px_rgba(42,92,69,0.5)]" data-id="element-121">
        GET THE 6-IN-1 BUNDLE NOW
      </a>

      {/* Trust badges */}
      <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-122">
        <span data-id="element-123">Instant Download</span>
        <span data-id="element-124">·</span>
        <span data-id="element-125">No Subscription</span>
        <span data-id="element-126">·</span>
        <span data-id="element-127">Lifetime Access</span>
      </p>
    </section>;
}